import { useSelector } from 'react-redux';
import LineItem from './LineItem';
import { useTranslation } from 'react-i18next';

const FinalizeSectionData = () => {
    const { t } = useTranslation();
    let formState = useSelector((state) => state.rootReducer.finalizeForm);
    const currency = useSelector((state) => state.shopifyReducer.ciems[0].currency);
    // let imp = formState.impStatus.split('-');
    return (
        <>
            {/*<Box style={{ width: '100%' }}>*/}
            <LineItem
                title={t('finalize.user_name')}
                value={formState.userName}
                price="-"></LineItem>
            <LineItem
                title={t('order_details.organization_name')}
                value={formState.bandName}
                price="-"></LineItem>
            <LineItem
                title={t('finalize.user_initials')}
                value={formState.userInitials}
                price="-"></LineItem>
            <LineItem
                title={t('finalize.impression_status')}
                value={t(`finalize.${formState.impStatus.SK}`)}
                price="-"></LineItem>
            <LineItem
                title={t('order_details.text_on_case')}
                value={
                    formState.isTextOnCase === true
                        ? `${t('finalize.text_on_case_yes')}`
                        : `${t('finalize.text_on_case_no')}`
                }></LineItem>
            {formState.isTextOnCase && (
                <>
                    <LineItem title="Top Line" value={formState.textOnTop} price="-"></LineItem>
                    <LineItem
                        title="Bottom Line"
                        value={formState.textOnBottom}
                        price="-"></LineItem>
                </>
            )}
            <LineItem
                title="Rush Processing"
                value={
                    formState.rushStatus.displayName !== '' ? formState.rushStatus.displayName : '-'
                }
                price={`${
                    formState.rushStatus.price !== '0.00'
                        ? currency + formState.rushStatus.price
                        : `-`
                }`}></LineItem>
            <LineItem
                title={t('finalize.order_notes')}
                value={formState.orderNotes !== undefined ? formState.orderNotes : '-'}
                price="-"></LineItem>
            {/*</Box>*/}
        </>
    );
};

export default FinalizeSectionData;
